import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'freeCardClockInFinish',
  state: {
    detailData: {
      weekTime: ''
    },
    singWeekData: {
      weekTime: '',
      ruleRemark: [
        {
          title: '',
          content: ''
        }
      ]
    }
  },
  effects: {
    * detail ({ payload }, { call, put }) {
      Toast.loading('加载中...')
      const { data: bizRes } = yield call(service.detail, payload)
      const { data: detailData } = bizRes
      yield put({
        type: 'save',
        payload: {
          detailData
        }
      })
      Toast.hide()
      return bizRes
    },
    * rule ({ payload }, { call, put }) {
      const { data: bizRes } = yield call(service.rule, payload)
      const { data: singWeekData } = bizRes
      yield put({
        type: 'save',
        payload: {
          singWeekData
        }
      })
      return bizRes
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
